export default "__VITE_ASSET__a985104d__"